import React, { useEffect, useState } from "react";

const AnimatedCounter = ({ end, duration = 2000 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const startTime = performance.now();

    const step = (timestamp) => {
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const value = Math.floor(progress * end);
      setCount(value);

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        setCount(end); // ensure it ends exactly at `end`
      }
    };

    requestAnimationFrame(step);
  }, [end, duration]);

  // Formatting with commas
  const formatted =
    end >= 1e9
      ? `${(count / 1e9).toFixed(1)} billion+`
      : count.toLocaleString() + "+";

  return <span>{formatted}</span>;
};

const StatsSection = () => {
  return (
    <section className="text-center py-16 text-white">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-2xl sm:text-3xl md:text-4xl ">
          The destination for beauty salons and restaurants
        </h2>
        <p className="mt-4 text-sm sm:text-base text-textGray">
          One solution, one software. Trusted by the best in the beauty and
          wellness industry
        </p>

        <h1 className="text-5xl sm:text-6xl font-bold mt-12">
          <AnimatedCounter end={120_000} />
        </h1>
        <p className="mt-2 text-textGray">
          Appointments booked and ordered on Loklai
        </p>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-8">
          <div>
            <h3 className="text-2xl font-semibold">
              <AnimatedCounter end={110} />
            </h3>
            <p className="text-textGray mt-1"> businesses</p>
          </div>
          <div>
            <h3 className="text-2xl font-semibold">
              <AnimatedCounter end={3} />
            </h3>
            <p className="text-textGray mt-1">countries</p>
          </div>
          <div>
            <h3 className="text-2xl font-semibold">
              <AnimatedCounter end={120} />
            </h3>
            <p className="text-textGray mt-1"> professional staffs</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
